import { Link } from 'react-router-dom';
import { trendingComics } from '@/mocks/comics';
import type { Comic } from '@/types';

function ComicCard({ comic }: { comic: Comic }) {
  const statusLabel = comic.status === 'ongoing' ? '连载中' : '已完结';

  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-300 transition-all cursor-pointer"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={comic.cover}
          alt={`${comic.title} - 韩漫在线免费阅读`}
          title={`${comic.title} - 韩漫在线免费阅读`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 right-2">
          <span className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
            comic.status === 'ongoing' ? 'bg-primary-500 text-background-50' : 'bg-secondary-500 text-background-50'
          }`}>
            {statusLabel}
          </span>
        </div>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1 mb-1">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 mb-2">{comic.author}</p>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-500 text-xs"></i>
            <span className="text-xs font-medium text-foreground-700">{comic.rating}</span>
          </div>
          <span className="text-xs text-foreground-400">{comic.chapters}话</span>
        </div>
      </div>
    </Link>
  );
}

export default function HotRecommend() {
  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">热门推荐</h2>
            <p className="text-sm text-foreground-500">最受读者欢迎的韩漫作品</p>
          </div>
          <Link
            to="/category/all"
            className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-5" data-product-shop="">
          {trendingComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}